export default {
  data() {
    return {
      searchSchema: [
        {
          label: '日期',
          type: 'rangePicker',
          itemName: 'date',
          format: 'YYYY-MM-DD',
        },
        {
          label: '融资渠道',
          type: 'select',
          itemName: 'channel',
          allowClear: true,
          selectList: [
            {
              text: 'IFC明细',
              value: 'IFC',
            },
            {
              text: '阜锦明细',
              value: '阜锦',
            },
            {
              text: '联想金融明细',
              value: '联想金融',
            },
            {
              text: '中行明细',
              value: '中行',
            },
          ],
          placeholder: '总明细',
        },
      ],
      searchForm: {
        date: [],
        channel: '',
      },
      pageData: {
        pageSize: 10,
        current: 1,
        total: 0,
        showTotal: total => `共${total}条`,
      },
      tableData: [],
      tableColumns: [
        {
          fixed: 'left',
          title: '序号',
          width: 80,
          customRender: (text, record, index) => {
            return (
              (this.pageData.current - 1) * this.pageData.pageSize + index + 1
            )
          },
        },
        {
          title: '日期',
          width: 120,
          dataIndex: 'date',
        },
        {
          title: '融资授信总敞口',
          width: 140,
          dataIndex: 'loanCreditExposure',
        },
        {
          title: '本月融资合计',
          width: 140,
          dataIndex: 'thisMonthLoan',
        },
        {
          title: '月末可用融资敞口合计',
          width: 180,
          dataIndex: 'endMonthLoanExposure',
        },
        {
          title: '本月底融资欠款总余额',
          width: 180,
          dataIndex: 'endMonthLoanDebt',
        },
        {
          title: '下月到期融资额',
          width: 150,
          dataIndex: 'nextMonthExpireLoan',
        },
        {
          title: '下月可融资总额',
          width: 150,
          dataIndex: 'nextMonthLoan',
        },
        {
          title: '本月销售额',
          width: 150,
          dataIndex: 'thisMonthSale',
        },
        {
          title: '融资销售占比',
          width: 150,
          dataIndex: 'loanSaleRate',
        },
        {
          title: '融资同比增长率',
          width: 150,
          dataIndex: 'loanGrowthRate',
        },
        {
          title: '销售额同比增长率',
          width: 150,
          dataIndex: 'saleGrowthRate',
        },
        {
          title: '自投率【（应收+库存-应付）/（应收+库存）】',
          width: 340,
          dataIndex: 'selfInvestRate',
        },
        {
          title:
            '净自投(应收+库存-应付-本月底联想平台融资欠款余额)/(应收+库存)',
          width: 460,
          dataIndex: 'selfInvest',
        },
      ],
    }
  },
  methods: {
    // 查询
    handleSearch(data) {
      this.searchForm = { ...this.searchForm, ...data }
      this.pageData.current = 1
      this._getTableData()
    },
    // 点击分页按钮
    handleClickPage({ current, pageSize }) {
      this.pageData = { ...this.pageData, current, pageSize }
      this._getTableData()
    },
  },
}
